import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouteObject, useLocation, useRoutes } from 'react-router-dom';
import { routesConfig } from './routesConfig';
import { MainContainer } from './components';
import { SnackbarProvider, ThemeProvider } from './providers';
import { I18nextProvider } from 'react-i18next';
import { i18n } from './i18next';
import CookieBanner from './components/CookieBanner/CookieBanner';
import ReactGA from 'react-ga4';
import { useEffect } from 'react';
import './App.css';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 0,
      gcTime: 0,
    },
  },
});

export const App = () => {
  const routes = useRoutes(routesConfig as RouteObject[]);
  const location = useLocation();
  const measurementId = process.env.REACT_APP_GA_MEASUREMENT_ID;

  useEffect(() => {
    // if (process.env.NODE_ENV === 'production') {
    if (measurementId) {
      ReactGA.initialize(measurementId);
    }
  }, []);

  useEffect(() => {
    // if (process.env.NODE_ENV === 'production') {
    if (measurementId) {
      ReactGA.send({
        hitType: 'pageview',
        page: location.pathname + location.search,
      });
    }
  }, [location]);

  return (
    <I18nextProvider i18n={i18n}>
      <ThemeProvider>
        <SnackbarProvider>
          <QueryClientProvider client={queryClient}>
            <MainContainer>{routes}</MainContainer>
            <CookieBanner />
          </QueryClientProvider>
        </SnackbarProvider>
      </ThemeProvider>
    </I18nextProvider>
  );
};
